import { useAppDispatch, useAppSelector } from "../redux";
import {
  CurrentViewType,
  SelectedEntityView,
  setView,
} from "../redux/slices/board";

export const useToggleView = (key: keyof SelectedEntityView) => {
  const { selectedView, selectedBoard } = useAppSelector((store) => store.board);
  const dispatch = useAppDispatch();

  return {
    selectedBoard: selectedBoard?.[key],
    isBoardView: selectedView[key] === "board",
    toggleView: (data: CurrentViewType) =>
      dispatch(setView({ key, value: data })),
  };
};
